import { createReducer, on, Action } from '@ngrx/store';
import * as actions from './online-menu.actions';

const initialState: OLO.State.OnlineMenu = {
    isDownloading: false,
    hasSucceeded: false,
    hasFailed: false,
    downloadedDate: null,
    pickupDate: null,
    locationNo: null,
    orderTypeId: null,
    data: null,
};

export const onlineMenuReducerFn = createReducer(
    initialState,
    on(actions.OnlineMenuPagesRequest, (state, action) => ({
        ...state,
        isDownloading: true,
        hasSucceeded: false,
        hasFailed: false,
        pickupDate: action.pickupDate,
        locationNo: action.locationNo,
    })),
    on(actions.OnlineMenuPagesSuccessRequest, (state, action) => ({
        ...state,
        isDownloading: false,
        hasSucceeded: true,
        hasFailed: false,
        locationNo: action.locationNo,
        data: action.payload,
        downloadedDate: new Date().getTime(),
        orderTypeId: action.orderTypeId,
    })),
    on(actions.OnlineMenuPageErrorRequest, (state, action) => ({
        ...state,
        isDownloading: false,
        hasSucceeded: false,
        hasFailed: true,
        locationNo: action.locationNo,
        orderTypeId: action.orderTypeId,
        data: null,
    })),
);

export function onlineMenuReducer(state: OLO.State.OnlineMenu | undefined, action: Action) {
    return onlineMenuReducerFn(state, action);
}
